const container = document.querySelector('.program-about__link');
if (container) {
    const height = container.dataset.height !== undefined ? container.dataset.height : 115;
    let textHeight = document.getElementById('textAboutProgram').offsetHeight;
    if (textHeight > height) {
        if (height < 115) {
            document.querySelector('.program-about__text').style.maxHeight = height + 'px'
        }
        document.querySelector('.program-about__text').classList.add('hide')
        document.querySelector('.program-about__link').classList.add('active')
    }
    document.querySelector('.program-about__link').onclick = () => {
        changeAboutText(height)
    }
}

function changeAboutText(height) {
    if (height < 115) {
        document.querySelector('.program-about__text').style.maxHeight = document.querySelector('.program-about__text').style.maxHeight === height + 'px' ? '' : height + 'px'
    }
        document.querySelector('.program-about__text').classList.toggle('hide')
    document.querySelector('.program-about__link').classList.toggle('show')
    let textHeight = document.getElementById('textAboutProgram').offsetHeight;
    if (textHeight > height) {
        document.getElementById('textAboutProgramLink').innerHTML = 'свернуть'
    } else {
        document.getElementById('textAboutProgramLink').innerHTML = 'подробнее'
    }
}